/** Glass placeholder with a light sweep while data loads. */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded bg-ink/[0.06] ${className}`} aria-hidden="true">
      <div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/70 to-transparent" />
    </div>
  );
}

export function GameCardSkeleton() {
  return (
    <div className="card flex flex-col p-4">
      <div className="mb-3 flex items-center justify-between"><Skeleton className="h-5 w-16" /><Skeleton className="h-3 w-24" /></div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3"><Skeleton className="h-7 w-7 !rounded-full" /><div className="flex-1"><Skeleton className="h-4 w-2/3" /><Skeleton className="mt-1.5 h-3 w-20" /></div></div>
        <div className="flex items-center gap-3"><Skeleton className="h-7 w-7 !rounded-full" /><div className="flex-1"><Skeleton className="h-4 w-1/2" /><Skeleton className="mt-1.5 h-3 w-20" /></div></div>
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-line pt-3"><Skeleton className="h-3 w-20" /><Skeleton className="h-3 w-14" /></div>
    </div>
  );
}

export function SkeletonGrid({ n = 8 }: { n?: number }) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{Array.from({ length: n }, (_, i) => <GameCardSkeleton key={i} />)}</div>;
}
